import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SurveysOpinionTaskService } from '../../../services/surveys-opinion-task.service';

@Component({
  selector: 'app-survey-tasks-logs',
  standalone: false,
  templateUrl: './survey-tasks-logs.component.html'
})
export class SurveyTasksLogsComponent implements OnInit {
  dataLoading = false
  @Input() recordId!: number;
  @Output() close = new EventEmitter<boolean>();
  recordsData: any[] = [];

  constructor(
    private service: SurveysOpinionTaskService
  ) { }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    this.dataLoading = true
    this.service.getTaskLogs(this.recordId).subscribe((data) => {
      this.recordsData = data as any[];
      this.dataLoading = false
    }, (error: any) => {

    })
  }
}
